import React from "react";

import { ConfigProvider } from "antd";

const Theme = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        components: {},
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default Theme;
